// Stable React list keys for data that carries no id of its own.

const contentKey = (item) => {
  if (item === null || item === undefined) return '';
  if (typeof item !== 'object') return String(item);
  return Object.values(item)
    .filter((value) => typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')
    .join('|');
};

// Returns [{ item, key }] where key comes from the item's own content and
// repeats are suffixed so duplicate values still render unique keys.
export const keyed = (items, keyOf) => {
  const seen = new Map();
  return (items || []).map((item) => {
    const base = String((keyOf ? keyOf(item) : contentKey(item)) ?? '') || 'row';
    const count = seen.get(base) || 0;
    seen.set(base, count + 1);
    return { item, key: count ? `${base}#${count}` : base };
  });
};

export const skeletonKeys = (count, prefix = 'skeleton') =>
  Array.from({ length: count }, (_, position) => `${prefix}-${position}`);

// Editable rows get a client-side uid so keys survive edits, inserts and removals.
export const withUids = (rows) => (rows || []).map((row) => (row.uid ? row : { ...row, uid: crypto.randomUUID() }));

export const stripUids = (rows) => (rows || []).map(({ uid, ...rest }) => rest);
